/**
 * Mock data pre štatistiky
 */

export const statistics = {
  // Prehľad celkových štatistík
  overview: {
    totalOfficials: 1247,
    totalStatements: 4532,
    totalRequests: 89,
    totalInitiatives: 23,
    totalOvms: 156,
  },

  // Štatistiky oznámení podľa stavu
  statementsByState: [
    { state: "NEW", name: "Nové", count: 234 },
    { state: "ACCEPT", name: "Schválené", count: 3876 },
    { state: "INCOMPLETE", name: "Neúplné", count: 312 },
    { state: "REJECT", name: "Zamítnuté", count: 110 },
  ],

  // Štatistiky oznámení podľa typu
  statementsByType: [
    { type: "INGOING", name: "Vstupní", count: 1123 },
    { type: "ONGOING", name: "Průběžné", count: 2876 },
    { type: "OUTGOING", name: "Výstupní", count: 456 },
    { type: "POINT3", name: "Dle bodu 3", count: 77 },
  ],

  // Štatistiky oznámení podľa rokov
  statementsByYear: [
    { year: 2020, count: 623 },
    { year: 2021, count: 712 },
    { year: 2022, count: 856 },
    { year: 2023, count: 934 },
    { year: 2024, count: 1021 },
    { year: 2025, count: 386 },
  ],

  // Štatistiky funkcionárov podľa typu funkcie
  officialsByFunction: [
    { function: "poslanec", count: 200 },
    { function: "senátor", count: 81 },
    { function: "hejtman", count: 14 },
    { function: "primátor", count: 27 },
    { function: "starosta", count: 456 },
    { function: "člen rady kraje", count: 127 },
    { function: "člen rady obce", count: 342 },
  ],

  // Štatistiky žiadostí
  requestsByState: [
    { state: "NEW", name: "Nové", count: 12 },
    { state: "ACCEPT", name: "Schválené", count: 67 },
    { state: "REJECT", name: "Zamítnuté", count: 10 },
  ],

  // Štatistiky podnetov
  initiativesByState: [
    { state: "NEW", name: "Nové", count: 5 },
    { state: "INVESTIGATION", name: "V šetření", count: 8 },
    { state: "CLOSED", name: "Uzavřené", count: 10 },
  ],

  // Štatistiky podnetov podľa výsledku
  initiativesByResult: [
    { result: "JUSTIFIED", name: "Důvodné", count: 3 },
    { result: "UNJUSTIFIED", name: "Nedůvodné", count: 5 },
    { result: "PARTIAL", name: "Částečně důvodné", count: 2 },
  ],

  // Mesačné štatistiky pre grafy
  monthlyStats: [
    { month: "2024-01", statements: 78, requests: 5, initiatives: 1 },
    { month: "2024-02", statements: 82, requests: 3, initiatives: 2 },
    { month: "2024-03", statements: 95, requests: 8, initiatives: 1 },
    { month: "2024-04", statements: 91, requests: 6, initiatives: 3 },
    { month: "2024-05", statements: 87, requests: 4, initiatives: 0 },
    { month: "2024-06", statements: 76, requests: 7, initiatives: 2 },
    { month: "2024-07", statements: 65, requests: 2, initiatives: 1 },
    { month: "2024-08", statements: 58, requests: 3, initiatives: 1 },
    { month: "2024-09", statements: 89, requests: 9, initiatives: 2 },
    { month: "2024-10", statements: 102, requests: 11, initiatives: 4 },
    { month: "2024-11", statements: 94, requests: 8, initiatives: 2 },
    { month: "2024-12", statements: 71, requests: 5, initiatives: 1 },
  ],

  // Top OVM podľa počtu funkcionárov
  topOvmsByOfficials: [
    { ovmName: "Poslanecká sněmovna", count: 200 },
    { ovmName: "Senát ČR", count: 81 },
    { ovmName: "Magistrát hl. m. Prahy", count: 65 },
    { ovmName: "Statutární město Brno", count: 55 },
    { ovmName: "Jihomoravský kraj", count: 45 },
    { ovmName: "Středočeský kraj", count: 42 },
    { ovmName: "Moravskoslezský kraj", count: 40 },
  ],
};

export default statistics;
